import {store} from "../redux/store";
import {listArticles} from "../action/listArticles";
import {setCurrentEventPlaceId} from "../redux/actions/setCurrentEventPlaceId";
import {getCurrentEventPlaceId} from "../util/event-place";
import {setFilteredArticles} from "../redux/actions/setFilteredArticles";

export const articleFilterLoader = async (args) => {
    store.dispatch(setCurrentEventPlaceId({ eventPlaceId: getCurrentEventPlaceId() }));
    store.dispatch(setFilteredArticles(await listArticles({ categoryId: args.params.categoryId })));
    return true;
}
